import styled from 'styled-components';

import colors from '@utils/colors';
import fonts, { weights } from '@utils/fonts';
import { Heading as UnstyledHeading } from '@components/type';

export const Dropdown = styled.div`
  position: absolute;
  top: 100%;
  right: -3px;
  left: -3px;
  z-index: 2;
  max-height: 300px;
  overflow-y: auto;
  padding: 16px;
  background-color: ${colors.N0};
  border: 3px solid ${colors.B100};
  border-top: 0;
  border-radius: 0 0 8px 8px;
  opacity: 0;
  pointer-events: none;
  transform: translateY(16px);
  transition: opacity 150ms linear, transform 200ms ease;
`;

export const Heading = styled(UnstyledHeading)`
  color: ${colors.B500};
`;

export const Item = styled.div`
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const Search = styled.div`
  flex: 1;
  position: relative;

  & > svg {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 16px;
    height: 20px;
    width: 20px;
    margin: auto 0;
    pointer-events: none;
  }
`;

export const SearchInput = styled.input`
  padding: 8px 4px;
  width: 100%;
  color: ${colors.B500};
  font-family: ${props => fonts(props.theme.locale).SANS_CONDENSED};
  font-size: 20px;
  font-weight: ${weights.BOLD};
  line-height: 120%;
  border: 0;
  outline: 0;

  &::placeholder {
    color: ${colors.B200};
  }
`;

export const Section = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  position: relative;
  margin: 8px 0;
  padding: 8px 16px;

  &::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: -11px;
    left: 0;
    height: 11px;
  }

  &:last-child {
    padding-right: 0;

    & ${Dropdown} {
      right: 0;
    }
  }

  &:hover ${Dropdown} {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(11px);
  }

  & > svg {
    height: 16px;
    width: 16px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  border-top: 3px solid ${colors.B100};
  border-bottom: 3px solid ${colors.B100};

  & > *:not(:last-child) {
    border-right: 3px solid ${colors.B100};
  }
`;
